import {CustomTag, CustomTagsGateway} from '../domain';
import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {map, Observable} from 'rxjs';
import {BASE_URL, BffTagResponse, TagsBffListResponse} from './domain';
import {tagBffResponseToCustomTagMapper, tagListBffMapper,} from './mappers/bff.mapper';
import {generateRequestTimeLogHeader} from 'src/app/core/interceptors/log.interceptor';

@Injectable()
export class CustomTagsBffGateway extends CustomTagsGateway {
  constructor(
    private httpClient: HttpClient,
    @Inject(BASE_URL) private bffUrl: string
  ) {
    super();
  }

  create(aggregate: CustomTag): Observable<CustomTag> {
    const body = {...aggregate}
    return this.httpClient
      .post<BffTagResponse>(
        `${this.bffUrl}/tag`,
        body,
        {
          headers: generateRequestTimeLogHeader('tags-create'),
        }
      )
      .pipe(map(tagBffResponseToCustomTagMapper));
  }

  list(params: {
    companiesId: Array<string>;
  }): Observable<CustomTag[]> {
    return this.httpClient
      .get<TagsBffListResponse>(`${this.bffUrl}/tag/find-by-companies`, {
        params: {companiesIds: params.companiesId.join(',')},

        headers: generateRequestTimeLogHeader('tags-list'),
      })
      .pipe(map(tagListBffMapper));
  }

  remove(id: number): Observable<void> {
    return this.httpClient.delete<void>(
      `${this.bffUrl}/tag/${id}`,

      {
        headers: generateRequestTimeLogHeader('tags-delete'),
      }
    );
  }

  update(tag: CustomTag): Observable<CustomTag> {
    const body = {...tag}
    return this.httpClient
      .put<BffTagResponse>(
        `${this.bffUrl}/tag/${tag.id}`,
        body,
        {
          headers: generateRequestTimeLogHeader('tags-update'),
        }
      )
      .pipe(map(tagBffResponseToCustomTagMapper));
  }

  find(id: number): Observable<CustomTag> {
    return this.httpClient
      .get<BffTagResponse>(`${this.bffUrl}/tag/${id}`, {
        headers: generateRequestTimeLogHeader('tags-find'),
      })
      .pipe(map(tagBffResponseToCustomTagMapper));
  }
}
